import vPaymentCard from '@/components/v-payment-card';
import utils from '../utils';

/**
 * Creates a `router-link` component to link within the app.
 * @param {CachedColumn} cachedColumn
 * @param {Object} rowData
 * @param {Function} createElement
 * @returns {Array}
 */
export default function paymentCardColumn({cachedColumn, rowData, createElement}) {
    const badges = utils.getCellValues({cachedColumn, rowData});
    let children;
    if (badges.length) {
        // reduce values into an array of badge elements
        const reducer = (reduced, value) => reduced.concat(createElement(
            vPaymentCard,
            {
                attrs: {title: value},
                props: {
                    type: value,
                },
            },
        ));
        children = utils.separateChildren({
            values: badges.reduce(reducer, []),
            createElement,
            delimiter: ' ',
        });
    } else {
        // render an empty cell element
        children = [utils.getEmptyCellElement(createElement)];
    }

    return [
        'div',
        children,
    ];
}
